// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3eCqS","vLegacy":"SelectSecondary_vLegacy__bQCDt","error":"SelectSecondary_error__941Wn","disabled":"SelectSecondary_disabled__21Tww"};